// extracted by mini-css-extract-plugin
export default {"counter":"style_counter__BTrX7","year":"style_year__xxze3","course":"style_course__UCez7","studies":"style_studies__q5PI6","count-up":"style_count-up__Ds58f"};